import { service, type Registry as Services } from '@ember/service';

import * as Sentry from '@sentry/ember';
import BaseSessionService from 'ember-simple-auth/services/session';
import window from 'ember-window-mock';

export default class SessionService extends BaseSessionService {
  @service declare currentUser: Services['current-user'];
  // @ts-expect-error -- this service is not typed yet
  @service store;
  // @ts-expect-error -- this service is not typed yet
  @service router;

  async handleAuthentication(routeAfterAuthentication: string): Promise<void> {
    try {
      await this.currentUser.load();
      // If a language switch happened before the session started, set the new locale in the user profile
      let user = this.currentUser.user;
      let loggedOutLocaleCode = sessionStorage?.getItem('logged-out-locale-code');
      if (user && loggedOutLocaleCode) {
        user.set('locale', loggedOutLocaleCode);
        await user.save();
        sessionStorage?.removeItem('logged-out-locale-code');
      }
    } catch {
      await this.invalidate();
    }
    /**
     * Redirect to the specified routeAfterAuthentication in the ember-simple-auth config after successful authentication
     */
    super.handleAuthentication(routeAfterAuthentication);
  }

  get logoutUrl(): string {
    let [redirectionToken] = this.store.peekAll('redirection-token');
    let [registerRedirectionToken] = this.store.peekAll('register-redirection-token');

    let token = redirectionToken ?? registerRedirectionToken;

    if (token) {
      return this.router.urlFor('welcome', token);
    }
    return '/';
  }

  handleInvalidation(): void {
    this.currentUser.user = null;
    Sentry.getCurrentScope().setUser(null);
    Sentry.getCurrentScope().setTag('organization_id', null);

    window.location.replace(this.logoutUrl);
  }
}

declare module '@ember/service' {
  interface Registry {
    session: SessionService;
  }
}
